import {post} from 'back-connector'
import {ENDPOINTS} from '@/constants/endpoints'
import {PasswordRecoveryRequest} from '@/stores/password-recovery/models'

export const recoverPassword = (data: PasswordRecoveryRequest) =>
    post(ENDPOINTS.RESET_PASSWORD, data)
